var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift"},[_c('Head',{attrs:{"type":"back","name":"gift","title":"스탬프 교환 상품"}}),_c('div',{staticClass:"tour_sub_wrap"},[_c('GiftPoint'),_c('GiftList'),_c('GiftGuide'),(_vm.popupGift.open)?_c('PopupGiftReceive'):_vm._e(),_c('PopupSns'),_c('PopupImpression',{attrs:{"title":_vm.introData.mingle_title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }